var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-select',_vm._g(_vm._b({attrs:{"loading":_vm.loading,"options":_vm.roleOptions,"filterable":""},on:{"visible-change":_vm.visibleChange},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'form-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }